<template>
  <el-form
    :model="form"
    ref="form"
    class="dialog-form-default"
    :disabled="disabledForm"
  >
    <div class="row">
      <div class="col-sm-auto col-12">
        <el-form-item
          :label="L10n('aircraft-model')"
          prop="aircraftModel"
          :rules="getValidationRule('required,minlength')"
          class="material-style">
          <el-input
            :value="form.aircraftModel"
            @input="form.aircraftModel = valueTrimLeft($event)"
            @change="updateModelItem('aircraftModel', { required: true })"
          />
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-auto col-12">
        <el-form-item
          :label="L10n('aircraft-series')"
          prop="aircraftSeries"
          class="material-style">
          <el-input
            :value="form.aircraftSeries"
            @input="form.aircraftSeries = valueTrimLeft($event)"
            @change="updateModelItem('aircraftSeries')"/>
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-auto col-12">
        <el-form-item
          :label="L10n('aircraft-manufacturer')"
          prop="aircraftManufacturer"
          class="material-style">
          <el-input
            :value="form.aircraftManufacturer"
            @input="form.aircraftManufacturer = valueTrimLeft($event)"
            @change="updateModelItem('aircraftManufacturer')"/>
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-auto col-12">
        <el-form-item
          :label="L10n('aircraft-engine-model')"
          prop="aircraftEngineModel"
          class="material-style">
          <el-input
            :value="form.aircraftEngineModel"
            @input="form.aircraftEngineModel = valueTrimLeft($event)"
            @change="updateModelItem('aircraftEngineModel')"/>
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-auto col-12">
        <el-form-item
          :label="L10n('aircraft-engine-series')"
          prop="aircraftEngineSeries"
          class="material-style">
          <el-input
            :value="form.aircraftEngineSeries"
            @input="form.aircraftEngineSeries = valueTrimLeft($event)"
            @change="updateModelItem('aircraftEngineSeries')"/>
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'

export default {
  name: 'FormGeneralAircrafts',
  mixins: [Form]
}
</script>
